import { onCleanup, createEffect } from "solid-js";
import type { Accessor } from "solid-js";

export function useOutsideClick(
  element: Accessor<HTMLElement | undefined>,
  callback: () => void,
  excludeElement?: Accessor<HTMLElement | undefined>
) {
  createEffect(() => {
    // Only attach listener if the main element (dropdown) is actually present
    // and the dropdown is intended to be interactable (i.e., open).
    const targetElement = element();
    if (!targetElement) {
      return;
    }

    const handleClick = (event: Event) => {
      const excludedNode = excludeElement?.();

      if (targetElement.contains(event.target as Node)) {
        return;
      }

      if (excludedNode && excludedNode.contains(event.target as Node)) {
        return;
      }

      callback();
    };

    document.addEventListener("mousedown", handleClick);
    document.addEventListener("touchstart", handleClick);

    onCleanup(() => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("touchstart", handleClick);
    });
  });
}
